import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { 
  AiOutlineRocket, 
  AiOutlineGlobal, 
  AiOutlineSafety, 
  AiOutlineFund,
  AiOutlineTeam,
  AiOutlineTrophy
} from "react-icons/ai";
import "./WhitepaperStyles.css";
import RvpLogo from '../../Assets/RVP-logo.png';
import LuminaLogo from '../../Assets/luminar-logo.png';
import CeruleanLogo from '../../Assets/cerulean-logo.png';

const WhitepaperEmbeded = () => {
  return (
    <Container fluid className="litepaper-section mt-4">
      <Container>
        {/* Hero Section */}
          <section aria-labelledby="section-hero">
          <Row className="litepaper-hero">
          <Col className="text-center">
              <h1 id="section-hero" className="litepaper-title">
                FONTANA Ecosystem <span className="text-primary">Litepaper (Ver 2.2)
</span>
              </h1>
            <p className="litepaper-subtitle">
              Bridging Digital Assets with Real-World Utility Through Decentralized Economic Empowerment
            </p>
            <p className="mt-3"><a href="/roadmap" className="text-primary">Check the Road Map here</a></p>
          </Col>
        </Row>
          </section>

        {/* Section 1: Introduction */}
          <section aria-labelledby="section-1-heading">
          <Row className="litepaper-section-row mt-4">
          <Col>
            <div className="litepaper-section-header section-1-header">
                <AiOutlineRocket className="section-icon" aria-hidden="true" />
                <h2 id="section-1-heading">1. What is the FONTANA Ecosystem?</h2>
            </div>
            <Card className="litepaper-card section-1">
              <Card.Body>
                <p className="litepaper-text">
                  FONTANA is a utility token built to bridge the digital and physical worlds by 
                  rewarding trading activity with tangible real-world goods and virtual assets. 
                  Operating on principles of Economic Empowerment, Community Building, and Decentralized 
                  Governance, the ecosystem utilizes a unique tax structure to fund multiple sub-economies: 
                  Realityverse Points (RVP), LUMINA (Metaverse), and the ultra-scarce Cerulean Sovereign Token.
                </p>
                <Row className="mt-4 align-items-stretch">
                  <Col md={3} className="mb-3 d-flex">
                    <div className="pillar-card flex-fill h-100 d-flex flex-column align-items-center text-center p-3">
                      <div className="pillar-icon mb-2"><AiOutlineTrophy className="fs-3" style={{ color: '#ff7a00' }} /></div>
                      <h5 className="mt-0">Realityverse Points (RVP)</h5>
                      <p>Earned via buy trades and redeemable for physical goods such as air tickets and holiday packages.</p>
                    </div>
                  </Col>
                  <Col md={3} className="mb-3 d-flex">
                    <div className="pillar-card flex-fill h-100 d-flex flex-column align-items-center text-center p-3">
                      <div className="pillar-icon mb-2"><AiOutlineGlobal className="fs-3" style={{ color: '#00c2b8' }} /></div>
                      <h5 className="mt-0">LUMINA (Metaverse Token)</h5>
                      <p>The native medium of exchange for the Lumeria metaverse, generated through selling activity and project participation.</p>
                    </div>
                  </Col>
                  <Col md={3} className="mb-3 d-flex">
                    <div className="pillar-card flex-fill h-100 d-flex flex-column align-items-center text-center p-3">
                      <div className="pillar-icon mb-2"><AiOutlineSafety className="fs-3" style={{ color: '#007bff' }} /></div>
                      <h5 className="mt-0">Cerulean Sovereign Token</h5>
                      <p>A highly scarce, long-term store-of-value token and the ultimate vehicle for decentralized governance.</p>
                    </div>
                  </Col>
                  <Col md={3} className="mb-3 d-flex">
                    <div className="pillar-card flex-fill h-100 d-flex flex-column align-items-center text-center p-3">
                      <div className="pillar-icon mb-2"><AiOutlineFund className="fs-3" style={{ color: '#8e2de2' }} /></div>
                      <h5 className="mt-0">Strategic Ecosystem Projects</h5>
                      <p>A portfolio of real-world and digital ventures (business funding, real estate, dApps) that drive engagement and generate shared profits.</p>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        </section>

        {/* Section 2: FONTANA Use Cases */}
          <section aria-labelledby="section-2-heading">
          <Row className="litepaper-section-row">
          <Col>
            <div className="litepaper-section-header section-2-header">
                <AiOutlineRocket className="section-icon" aria-hidden="true" />
                <h2 id="section-2-heading">2. FONTANA Use Cases: The Primary Engine</h2>
            </div>
            <Card className="litepaper-card section-2">
              <Card.Body>
                <p className="litepaper-text mb-1">
                  The FONTANA token is the fundamental utility asset that powers every interaction within the ecosystem:
                </p>
                <Row className="mt-4 usecase-grid">
                  {/* Top row: 3 columns */}
                  <Col md={5} className="mb-3 d-flex">
                    <div className="usecase-box usecase-1 d-flex flex-column align-items-center text-center p-3 flex-fill h-100">
                      <div className="usecase-icon mb-3">
                        <div className="icon-circle" style={{ background: 'rgba(255,122,0,0.08)' }}>
                          <AiOutlineRocket className="fs-3" style={{ color: '#ff7a00' }} />
                        </div>
                      </div>
                      <h5>Primary Generator</h5>
                      <p>FONTANA acts as the catalyst for the economy; trading and holding generates RVP, LUMINA, and Cerulean Dust.</p>
                    </div>
                  </Col>
                  <Col md={5} className="mb-3 d-flex">
                    <div className="usecase-box usecase-2 d-flex flex-column align-items-center text-center p-3 flex-fill h-100">
                      <div className="usecase-icon mb-3">
                        <div className="icon-circle" style={{ background: 'rgba(0,194,184,0.08)' }}>
                          <AiOutlineGlobal className="fs-3" style={{ color: '#00c2b8' }} />
                        </div>
                      </div>
                      <h5>Trading Use Case</h5>
                      <p>Used in the P2P Marketplace to trade ecosystem goods, metaverse items, and digital assets directly between users.</p>
                    </div>
                  </Col>
                  <Col md={10} className="mb-3 d-flex">
                    <div className="usecase-box usecase-3 d-flex flex-column align-items-center text-center p-3 flex-fill h-100">
                      <div className="usecase-icon mb-3">
                        <div className="icon-circle" style={{ background: 'rgba(142,45,226,0.08)' }}>
                          <AiOutlineTeam className="fs-3" style={{ color: '#8e2de2' }} />
                        </div>
                      </div>
                      <h5>Voting Power & Governance</h5>
                      <p>Locking or HODLing FONTANA grants voting rights for shaping future developments through the Cerulean DAO.</p>
                    </div>
                  </Col>
                </Row>
                <Row className="mt-3 justify-content-center">
                  {/* Bottom row: 2 centered columns */}
                  <Col md={5}  className="mb-3 d-flex">
                    <div className="usecase-box usecase-4 d-flex flex-column align-items-center text-center p-3 flex-fill h-100">
                      <div className="usecase-icon mb-3">
                        <div className="icon-circle" style={{ background: 'rgba(255,193,7,0.08)' }}>
                          <AiOutlineTrophy className="fs-3" style={{ color: '#ffc107' }} />
                        </div>
                      </div>
                      <h5>Staking & Stability</h5>
                      <p>Locking tokens for set periods earns rewards, incentivizes long-term holding, and contributes to price stability.</p>
                    </div>
                  </Col>
                  <Col md={5}  className="mb-3 d-flex">
                    <div className="usecase-box usecase-5 d-flex flex-column align-items-center text-center p-3 flex-fill h-100">
                      <div className="usecase-icon mb-3">
                        <div className="icon-circle" style={{ background: 'rgba(40,167,69,0.08)' }}>
                          <AiOutlineFund className="fs-3" style={{ color: '#28a745' }} />
                        </div>
                      </div>
                      <h5>Project Participation</h5>
                      <p>FONTANA is required to enter ecosystem projects where users can earn returns, bonuses, or unique project-specific items.</p>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        </section>

        {/* Section 3: Core Ecosystem Offerings */}
          <section aria-labelledby="section-3-heading">
          <Row className="litepaper-section-row ">
          <Col>
            <div className="litepaper-section-header section-3-header">
                <AiOutlineTrophy className="section-icon" aria-hidden="true" />
                <h2 id="section-3-heading">3. Core Ecosystem Offerings</h2>
            </div>
            <Card className="litepaper-card section-3">
              <Card.Body>
                <p className="litepaper-text mb-1">
                  The ecosystem provides three distinct layers of value through unique transaction structures:
                </p>
                <Row className="mt-4">
                  <Col md={4} className="mb-4">
                    <div className="offering-card offering-rvp">
                      <div className="offering-icon"><img src={RvpLogo} alt="RVP logo" /></div>
                      <h5 className="poppins-light"><span className="purple">Realityverse Points (RVP)</span></h5>
                      <p>Earned through buy trades and redeemable for physical goods from the marketplace</p>
                    </div>
                  </Col>
                  <Col md={4} className="mb-4">
                    <div className="offering-card offering-lumina">
                      <div className="offering-icon"><img src={LuminaLogo} alt="Lumina logo" /></div>
                      <h5 className="poppins-light"><span className="purple">LUMINA Tokens</span></h5>
                      <p>Generated via trading activity and project participation, serving as the native medium of exchange for the metaverse</p>
                    </div>
                  </Col>
                  <Col md={4} className="mb-4">
                    <div className="offering-card offering-cerulean">
                      <div className="offering-icon"><img src={CeruleanLogo} alt="Cerulean logo" /></div>
                      <h5 className="poppins-light"><span className="purple">Cerulean Sovereign Token</span></h5>
                      <p>A highly scarce asset designed for long-term value storage and ultimate governance</p>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        </section>

        {/* Section 4: Lumeria */}
          <section aria-labelledby="section-4-heading">
          <Row className="litepaper-section-row">
          <Col>
            <div className="litepaper-section-header section-4-header">
                <AiOutlineGlobal className="section-icon" aria-hidden="true" />
                <h2 id="section-4-heading">4. Lumeria: The FONTANA Metaverse</h2>
            </div>
            <Card className="litepaper-card section-4">
              <Card.Body>
                <p className="litepaper-text mb-1">
                  Lumeria is a virtual world designed for social interaction, exploration, and Play-to-Earn (P2E) activities.
                </p>
                <Row className="mt-4">
                  <Col md={4} className="mb-3">
                    <div className="feature-box">
                      <h5 className="text-success">Economy</h5>
                      <p>Powered by LUMINA, which is generated whenever FONTANA tokens are sold in the official liquidity pool</p>
                    </div>
                  </Col>
                  <Col md={4} className="mb-3">
                    <div className="feature-box">
                      <h5 className="text-info">Utility</h5>
                      <p>Users can sell LUMINA for gamers, trade assets, customize avatars, and participate in a decentralized P2P marketplace</p>
                    </div>
                  </Col>
                  <Col md={4} className="mb-3">
                    <div className="feature-box">
                      <h5 className="text-warning">Sustainability</h5>
                      <p>To combat inflation, LUMINA used for in-game purchases and assets is permanently burned</p>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        </section>

        {/* Section 5: Cerulean */}
          <section aria-labelledby="section-5-heading">
          <Row className="litepaper-section-row">
          <Col>
            <div className="litepaper-section-header section-5-header">
                <span className="section-icon" style={{ fontSize: '2.5rem' }} aria-hidden="true">💎</span>
                <h2 id="section-5-heading">5. Cerulean: The Sovereign Concept</h2>
            </div>
            <Card className="litepaper-card cerulean-card section-5">
              <Card.Body>
                <p className="litepaper-text mb-1">
                  The Cerulean Sovereign Token is the ecosystem's ultimate store of value.
                </p>
                <div className="cerulean-features">
                  <div className="cerulean-feature">
                    <h5>Extreme Scarcity</h5>
                    <p>A single Cerulean token is programmatically minted only after reaching certain milestones</p>
                  </div>
                  <div className="cerulean-feature">
                    <h5>Cerulean Dust Protocol (CDP)</h5>
                    <p>A "Proof-of-Activity" engine that decentralizes ownership by rewarding "Daily Grinders" and "Economy Boosters"</p>
                  </div>
                  <div className="cerulean-feature">
                    <h5>Community Distribution</h5>
                    <p>90% of each minted token is allocated based on accumulated "Cerulean Dust" (weighted points) earned through:</p>
                    <Row className="mt-4">
                      <Col md={6} className="text-start">
                        <ul className="dust-activities mb-0">
                          <li><span className="multiplier">1x</span> Lumeria logins</li>
                          <li><span className="multiplier">1x</span> Selected activities in Lumeria/games</li>
                          <li><span className="multiplier">2x</span> Sell Trades</li>
                        </ul>
                      </Col>
                      <Col md={6} className="text-start">
                        <ul className="dust-activities mb-0">
                          <li><span className="multiplier">3x</span> Buy Trades</li>
                          <li><span className="multiplier">2x</span> Holding</li>
                          <li><span className="multiplier">4x</span> Social stewardship</li>
                        </ul>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        </section>

        {/* Section 6: DAO */}
          <section aria-labelledby="section-6-heading">
          <Row className="litepaper-section-row">
          <Col>
            <div className="litepaper-section-header section-6-header">
                <AiOutlineTeam className="section-icon" aria-hidden="true" />
                <h2 id="section-6-heading">6. Why the Cerulean DAO?</h2>
            </div>
            <Card className="litepaper-card section-5">
              <Card.Body>
                <p className="litepaper-text mb-1">
                  The transition to a Decentralized Autonomous Organization (DAO) is the final stage of the 
                  FONTANA roadmap, representing absolute decentralization.
                </p>
                <Row className="mt-4 align-items-stretch">
                  <Col md={4} className="mb-3 d-flex">
                    <div className="dao-benefit d-flex flex-column align-items-center text-center p-3 flex-fill h-100">
                      <div className="dao-icon mb-2">🎯</div>
                      <h5>Community Stewardship</h5>
                      <p className="mb-0">Power is transferred to FONTANA HODLers, who vote on protocol upgrades, treasury management, and CEX listings</p>
                    </div>
                  </Col>
                  <Col md={4} className="mb-3 d-flex">
                    <div className="dao-benefit d-flex flex-column align-items-center text-center p-3 flex-fill h-100">
                      <div className="dao-icon mb-2">🔒</div>
                      <h5>Security & Alignment</h5>
                      <p className="mb-0">Distributing control across the community reduces centralized points of failure</p>
                    </div>
                  </Col>
                  <Col md={4} className="mb-3 d-flex">
                    <div className="dao-benefit d-flex flex-column align-items-center text-center p-3 flex-fill h-100">
                      <div className="dao-icon mb-2">🤝</div>
                      <h5>Long-term Vision</h5>
                      <p className="mb-0">Aligns governance with the interests of committed long-term holders</p>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        </section>

        {/* Section 7: Tax Mechanisms */}
          <section aria-labelledby="section-7-heading">
          <Row className="litepaper-section-row">
          <Col>
            <div className="litepaper-section-header section-7-header">
                <AiOutlineSafety className="section-icon" aria-hidden="true" />
                <h2 id="section-7-heading">7. Tax Mechanisms & Economic Stability</h2>
            </div>
            <Card className="litepaper-card section-1">
              <Card.Body>
                <p className="litepaper-text mb-1">
                  FONTANA utilizes a reactive tax structure to protect market health and minimize economic failure.
                </p>
                <Row className="mt-4">
                  <div className="tax-mechanisms">
                  <div className="tax-item">
                    <div className="tax-badge buy-tax">1%</div>
                    <div className="tax-details">
                      <h5 className="section-6-left">Buy Tax</h5>
                      <p className="section-6-left">Applied to all purchases to maintain liquidity and discourage bots</p>
                    </div>
                  </div>
                  <div className="tax-item">
                    <div className="tax-badge base-tax">2%</div>
                    <div className="tax-details">
                      <h5 className="section-6-left">Base Sell Tax</h5>
                      <p className="section-6-left">Applied to standard sales within normal thresholds</p>
                    </div>
                  </div>
              {/*     <div className="tax-item">
                    <div className="tax-badge dump-tax">5%</div>
                    <div className="tax-details">
                      <h5 className="section-6-left">Dump Tax</h5>
                      <p className="section-6-left">Triggered by trades exceeding the Dynamic Anti-Volatility (DAV) threshold to discourage catastrophic whale sell-offs</p>
                    </div>
                  </div> */}
                  <div className="tax-item">
                    <div className="tax-badge svt-tax">5%</div>
                    <div className="tax-details">
                      <h5 className="section-6-left">SVT/ Price Check Tax</h5>
                      <p className="section-6-left"> SVT - Monitors total sell pressure is more than 11% of the LP, in a 3 miute window.
                        If breached activated for 60 seconds. Price Check - If the price drop in a block more than 10% or a single sell
                        cause 10% price drop 60 seconds of 5% tax activated. Sells under 500K voulume is taxed at regular rate during the 60 Seconds. </p>
                    </div>
                  </div>                

                </div>
                </Row>
                <div className="reasoning-box mt-4">
                  
                   <div className="special-note mt-3">
                    <p>
                      FONTANA’s Automated Recoil is designed to absorb sell pressure, to minimise the panic selling.
                       <br/>When a single transaction triggers a 10% price drop, a 5% tax 
                      is applied to taht trade:
                    </p>
                    <ul className="note-list">
                      <li><strong>3% Rewards:</strong> This goes straight into the other pools.</li>
                      <li><strong>2% Instant Recoil Fund:</strong> The contract takes this 2%, immediately swaps it and sees
                       if a threshold is met for USDT  swap, and buyback FONTANA tokens in the very same transaction.</li>
                    </ul>
                    <p>Essentially, the seller is forced to pay for a "green candle" that heals the price drop they just caused.
                     Instead of a crash, the community sees the chart "self-heal," turning the exit into instant support 
                     for everyone else.
                  </p>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        </section>

        {/* Section 8: Tax Distribution */}
          <section aria-labelledby="section-8-heading">
          <Row className="litepaper-section-row">
          <Col>
            <div className="litepaper-section-header section-8-header">
                <AiOutlineFund className="section-icon" aria-hidden="true" />
                <h2 id="section-8-heading">8. Tax Distribution & The Cerulean Vault</h2>
            </div>
            <Card className="litepaper-card section-2">
              <Card.Body>
                <p className="litepaper-text mb-1">
                  Collected taxes are funneled directly back into ecosystem growth:
                </p>
                <Row className="mt-4 align-items-stretch">
                  <Col md={6} lg={4} className="mb-3 d-flex">
                    <div className="distribution-card d-flex flex-column align-items-center text-center p-3 flex-fill h-100">
                      <div className="distribution-percentage">30%</div>
                      <h5>Bonus Pool</h5>
                      <p className="mb-0">Funds $100,000 lottery draws for active participants and provides additional liquidity</p>
                    </div>
                  </Col>
                  <Col md={6} lg={4} className="mb-3 d-flex">
                    <div className="distribution-card d-flex flex-column align-items-center text-center p-3 flex-fill h-100">
                      <div className="distribution-percentage">25%</div>
                      <h5>Development</h5>
                      <p className="mb-0">Allocated for ongoing platform maintenance and future upgrades</p>
                    </div>
                  </Col>
                  <Col md={6} lg={4} className="mb-3 d-flex">
                    <div className="distribution-card d-flex flex-column align-items-center text-center p-3 flex-fill h-100">
                      <div className="distribution-percentage">20%</div>
                      <h5>Realityverse Reward Pool</h5>
                      <p className="mb-0">Backs RVP redemptions and funds the Cerulean Token</p>
                    </div>
                  </Col>
                  <Col md={6} lg={4} className="mb-3 d-flex">
                    <div className="distribution-card d-flex flex-column align-items-center text-center p-3 flex-fill h-100">
                      <div className="distribution-percentage">10%</div>
                      <h5>Sovereign Chest</h5>
                      <p className="mb-0">This chest will be convrted to other Assets peridically. Eg: Gold, paintings, BTC etc</p>
                    </div>
                  </Col>
                  <Col md={6} lg={4} className="mb-3 d-flex">
                    <div className="distribution-card d-flex flex-column align-items-center text-center p-3 flex-fill h-100">
                      <div className="distribution-percentage">10%</div>
                      <h5>Burn</h5>
                      <p className="mb-0">Burning of FONTANA tokens until total supply reaches 5 billion or less</p>
                    </div>
                  </Col>
                  <Col md={6} lg={4} className="mb-3 d-flex">
                    <div className="distribution-card cerulean-vault-card d-flex flex-column align-items-center text-center p-3 flex-fill h-100">
                      <div className="distribution-percentage">5%</div>
                      <h5>Cerulean Vault</h5>
                      <p className="mb-0">Locked and removed from supply. Funds Cerulean token programmatic buyback</p>
                    </div>
                  </Col>
                </Row>
                <div className="vault-info mt-4">
                  <h5>The Cerulean Vault</h5>
                  <p>
                    A portion of the transaction tax (5%) is directed to the Cerulean Vault. This vault acts as 
                    a transparent, verifiable reserve that provides a buyback price for the Cerulean token by 
                    funding its programmatic buyback mechanism.
                  </p>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        </section>

        {/* Section 9: Integrated Projects */}
          <section aria-labelledby="section-9-heading">
          <Row className="litepaper-section-row mb-5">
          <Col>
            <div className="litepaper-section-header section-9-header">
                <span className="section-icon" style={{ fontSize: '2.5rem' }} aria-hidden="true">🚀</span>
                <h2 id="section-9-heading">9. Integrated Ecosystem Projects</h2>
            </div>
            <Card className="litepaper-card section-3">
              <Card.Body>
                <p className="litepaper-text mb-1">
                  FONTANA serves as an incubator for revenue-generating projects that drive token utility and value.
                </p>
                <Row>
                  <Col md={4} className="mb-3">
                    <div className="project-feature">
                      <h5 className="text-primary">Diversified Scope</h5>
                      <p>Includes real-world ventures (business funding, physical asset ownership) and digital projects (NFT collections, P2E games, dApps)</p>
                    </div>
                  </Col>
                  <Col md={4} className="mb-3">
                    <div className="project-feature">
                      <h5 className="text-success">Strategic Funding</h5>
                      <p>Vetted projects can bootstrap operations through Stablecoin Locking, which removes FONTANA tokens from the market to create instant scarcity and price support</p>
                    </div>
                  </Col>
                  <Col md={4} className="mb-3">
                    <div className="project-feature">
                      <h5 className="text-warning">Profit Sharing</h5>
                      <p>Participants share in the success of ventures through project-specific rewards and profit-sharing models, ensuring community-driven growth</p>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        </section>

        

        {/* Footer CTA */}
          {/* <Row className="litepaper-cta">
            <Col className="text-center">
              <h3>Join the FONTANA Revolution</h3>
              <p>Be part of the future of decentralized economic empowerment</p>
              <a href="/#join" className="btn btn-primary btn-lg mt-3" role="button" aria-label="Join the FONTANA Revolution">Get Started</a>
            </Col>
          </Row> */}
      </Container>
    </Container>
  );
};

export default WhitepaperEmbeded;
